import classNames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Tooltip from 'react-tooltip'

import ButtonWithLoading from '../ButtonWithLoading'
import { BellIcon, BlankBellIcon } from '../icons'

interface Props {
  className?: string
  onClick: () => Promise<void>
  isNotified?: boolean
}

const TOOLTIP_ID = 'notifications'

const NotificationsButton: React.FC<Props> = (props) => {
  const { t } = useTranslation()

  return (
    <span className={classNames('flex items-center', props.className)}>
      <ButtonWithLoading
        className="focus:outline-none"
        innerClass="flex flex-col items-center text-white md:flex-row md:items-center"
        onClick={props.onClick}
        spinnerProps={{ className: 'text-white', size: 24 }}
        data-tip
        data-for={TOOLTIP_ID}
      >
        {props.isNotified ? (
          <BellIcon className="h-6 w-6 lg:mr-1.5" />
        ) : (
          <BlankBellIcon className="h-6 w-6 lg:mr-1.5" />
        )}
        <span className="mt-1 text-xs md:text-base lg:mt-0">
          {t('Components.NotificationButton.notification')}
        </span>{' '}
      </ButtonWithLoading>
      <Tooltip id={TOOLTIP_ID} effect="solid" place="bottom">
        {props.isNotified
          ? t('Components.NotificationButton.disableNotifications')
          : t('Components.NotificationButton.enableNotifications')}
      </Tooltip>
    </span>
  )
}

export default NotificationsButton
